/* PAPAYA CLOTHING — Halloween theme layer */
(function () {
  if (window.__hwInit) return; window.__hwInit = true;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var NS = 'http://www.w3.org/2000/svg';
  var BAT_D = 'M20 6C18 3 16 3 15 6C12 2 6 2 0 6C4 7 6 10 7 13C9 11 11 11 13 13C15 11 17 12 20 16C23 12 25 11 27 13C29 11 31 11 33 13C34 10 36 7 40 6C34 2 28 2 25 6C24 3 22 3 20 6Z';
  function batSVG(w, color) { return '<svg width="' + w + '" height="' + (w / 2) + '" viewBox="0 0 40 20"><path fill="' + (color || '#2a3743') + '" d="' + BAT_D + '"/></svg>'; }
  function pumpkinHTML(s, cls, style) { return '<span class="hw-pk ' + (cls || '') + '" style="--s:' + s + 'px;' + (style || '') + '"><i class="st"></i><i class="a"></i><i class="b"></i><i class="c"></i></span>'; }
  window.hwPumpkin = pumpkinHTML;

  function webSVG(size, rings, color) {
    var svg = document.createElementNS(NS, 'svg'), n = 6, i, a;
    svg.setAttribute('width', size); svg.setAttribute('height', size); svg.setAttribute('viewBox', '0 0 ' + size + ' ' + size);
    svg.setAttribute('stroke', color); svg.setAttribute('stroke-width', '1'); svg.setAttribute('fill', 'none');
    for (i = 0; i <= n; i++) { a = (Math.PI / 2) * i / n; var l = document.createElementNS(NS, 'line'); l.setAttribute('x1', 0); l.setAttribute('y1', 0); l.setAttribute('x2', Math.cos(a) * size); l.setAttribute('y2', Math.sin(a) * size); svg.appendChild(l); }
    rings.forEach(function (r) {
      var d = '';
      for (var k = 0; k <= n; k++) {
        var aa = (Math.PI / 2) * k / n, x = Math.cos(aa) * size * r, y = Math.sin(aa) * size * r;
        if (!k) d = 'M' + x + ' ' + y; else { var am = (Math.PI / 2) * (k - .5) / n, c = size * r * .86; d += ' Q' + Math.cos(am) * c + ' ' + Math.sin(am) * c + ' ' + x + ' ' + y; }
      }
      var p = document.createElementNS(NS, 'path'); p.setAttribute('d', d); svg.appendChild(p);
    });
    return svg;
  }
  function initWebs(root) {
    $$('[data-hw-web]', root).forEach(function (el) {
      if (el.__done) return; el.__done = true;
      var size = +el.getAttribute('data-size') || 110;
      var mSize = +el.getAttribute('data-msize') || size;
      if (window.innerWidth < 600) size = mSize;
      var side = el.getAttribute('data-side') || 'left';
      var rings = size > 100 ? [0.28, 0.5, 0.72, 0.94] : [0.3, 0.55, 0.8];
      el.style[side] = '0';
      if (side === 'right') el.style.transform = (el.style.transform || '') + ' scaleX(-1)';
      el.style.opacity = el.getAttribute('data-opacity') || '.75';
      el.appendChild(webSVG(size, rings, el.getAttribute('data-color') || '#b9a89a'));
    });
  }
  function spiderHTML() {
    var legs = '';
    [-1, 1].forEach(function (s) { for (var k = 0; k < 3; k++) legs += '<span class="lg" style="top:' + (3 + k * 4) + 'px;' + (s < 0 ? 'right' : 'left') + ':9px;transform:rotate(' + (s * (k - 1) * 28) + 'deg)"></span>'; });
    return '<div class="th"></div><div class="bd">' + legs + '<span class="ey" style="left:2.5px"></span><span class="ey" style="right:2.5px"></span></div>';
  }
  function initDeco(root) {
    initWebs(root);
    $$('.hw-spider', root).forEach(function (el) { if (!el.__done) { el.__done = true; el.innerHTML = spiderHTML(); } });
    $$('[data-hw-bat]', root).forEach(function (el) { if (!el.__done) { el.__done = true; el.innerHTML = batSVG(+el.getAttribute('data-hw-bat') || 26, el.getAttribute('data-color')); } });
  }

  function initFX() {
    var host = $('[data-hw-fx]'); if (!host) return;
    var lvl = host.getAttribute('data-hw-fx'); if (lvl === 'off') return;
    var old = $('.hw-fx'); if (old) old.parentNode.removeChild(old);
    var nB = { subtle: 2, balanced: 3, bold: 6 }[lvl] || 3, nL = { subtle: 4, balanced: 8, bold: 14 }[lvl] || 8;
    var colors = ['#e8731c', '#f2a65a', '#c9561a', '#d99a3e'];
    var fx = document.createElement('div'); fx.className = 'hw-fx'; var html = '';
    for (var i = 0; i < nB; i++) html += '<div class="bat" style="top:' + (14 + i * 23) + '%;animation:hwBatFly ' + (22 + i * 6) + 's linear ' + (-i * 9) + 's infinite">' + batSVG(26 + (i * 9) % 16) + '</div>';
    for (var j = 0; j < nL; j++) html += '<span class="leaf" style="left:' + ((j * 47) % 96) + '%;width:' + (10 + (j % 3) * 3) + 'px;height:' + (6 + (j % 3) * 2) + 'px;background:' + colors[j % 4] + ';animation:hwLeaf ' + (16 + (j * 5) % 12) + 's linear ' + (-(j * 3.1)) + 's infinite"></span>';
    fx.innerHTML = html; document.body.appendChild(fx);
  }

  function initAnn() {
    var msgs = $$('.hw-ann-msg'); if (msgs.length < 2) return; var i = 0;
    setInterval(function () { msgs[i].classList.remove('on'); i = (i + 1) % msgs.length; msgs[i].classList.add('on'); }, 4000);
  }

  function openOv(id) { var o = document.getElementById(id); if (o) { o.classList.add('open'); document.documentElement.style.overflow = 'hidden'; document.body.style.overflow = 'hidden'; } }
  function closeOv(o) { o.classList.remove('open'); document.documentElement.style.overflow = ''; document.body.style.overflow = ''; }
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-hw-open]');
    if (op) { e.preventDefault(); var t = op.getAttribute('data-hw-open'); if (t === 'hw-cart-ov') Cart.open(); else openOv(t); return; }
    var cl = e.target.closest('[data-hw-close]');
    if (cl) { e.preventDefault(); closeOv(cl.closest('.hw-ov')); return; }
    var sub = e.target.closest('.hw-mnav-row button');
    if (sub) { var it = sub.closest('.hw-mnav-item'); it.classList.toggle('open'); sub.textContent = it.classList.contains('open') ? '\u2212' : '+'; return; }
    var q = e.target.closest('.hw-q > button');
    if (q) { var item = q.parentNode, was = item.classList.contains('open'); $$('.hw-q.open').forEach(function (x) { x.classList.remove('open'); x.querySelector('button i').textContent = '+'; }); if (!was) { item.classList.add('open'); q.querySelector('i').textContent = '\u2212'; } }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.hw-ov.open').forEach(closeOv); });

  var MF = window.HW_MONEY_FORMAT || '${{amount}}';
  function money(cents) {
    var n = (cents / 100);
    var a = n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return MF.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return a;
    });
  }
  var Cart = {
    get: function () { return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); },
    render: function (c) {
      $$('.hw-cart-count').forEach(function (el) { el.textContent = c.item_count; });
      var lines = $('#hw-cart-lines'), empty = $('#hw-cart-empty'), foot = $('#hw-cart-foot');
      if (!lines) return;
      if (!c.item_count) { lines.style.display = 'none'; foot.style.display = 'none'; empty.style.display = 'flex'; return; }
      empty.style.display = 'none'; lines.style.display = 'block'; foot.style.display = 'flex';
      lines.innerHTML = c.items.map(function (it) {
        var vt = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        return '<div class="hw-line"><a href="' + it.url + '" class="hw-line-img">' + (it.image ? '<img src="' + it.image + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="hw-line-info"><a href="' + it.url + '" style="font-size:15px;line-height:1.3">' + it.product_title + '</a>' + (vt ? '<span style="font-size:13px;color:#526b81">' + vt + '</span>' : '') +
          '<div class="hw-line-row"><div class="hw-qty"><button type="button" data-k="' + it.key + '" data-q="' + (it.quantity - 1) + '">\u2212</button><span>' + it.quantity + '</span><button type="button" data-k="' + it.key + '" data-q="' + (it.quantity + 1) + '">+</button></div>' +
          '<span style="font-family:Assistant,sans-serif;font-weight:600">' + money(it.final_line_price) + '</span></div>' +
          '<button type="button" class="hw-link" data-k="' + it.key + '" data-q="0">Remove</button></div></div>';
      }).join('');
      $('#hw-cart-sub').textContent = money(c.total_price);
    },
    refresh: function () { return Cart.get().then(Cart.render); },
    open: function () { openOv('hw-cart-ov'); Cart.refresh(); },
    change: function (key, q) { return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: Math.max(0, q) }) }).then(function (r) { return r.json(); }).then(Cart.render); },
    add: function (id, qty) { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: id, quantity: qty }] }) }).then(function (r) { if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Could not add to cart'); }); return r.json(); }); },
    pulse: function () { $$('.hw-badge').forEach(function (b) { b.classList.add('pulse'); setTimeout(function () { b.classList.remove('pulse'); }, 450); }); }
  };
  window.hwCart = Cart;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#hw-cart-lines [data-k]');
    if (b) Cart.change(b.getAttribute('data-k'), +b.getAttribute('data-q'));
  });

  function parseDate(s) {
    var m = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):?(\d{2})?/.exec(s || '');
    return m ? new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +(m[6] || 0)).getTime() : new Date(s).getTime();
  }
  function initCountdowns() {
    var els = $$('[data-hw-cd]'); if (!els.length) return;
    function pad(x) { x = String(x); return x.length < 2 ? '0' + x : x; }
    function tick() {
      els.forEach(function (el) {
        var d = Math.max(0, parseDate(el.getAttribute('data-hw-cd')) - Date.now()) || 0;
        var v = { d: Math.floor(d / 864e5), h: Math.floor(d / 36e5) % 24, m: Math.floor(d / 6e4) % 60, s: Math.floor(d / 1e3) % 60 };
        $$('[data-u]', el).forEach(function (u) { u.textContent = pad(v[u.getAttribute('data-u')]); });
      });
    }
    tick(); setInterval(tick, 1000);
  }

  function tween(el, frames, dur, delay, ease) {
    if (el.animate) { el.animate(frames, { duration: dur, delay: delay || 0, easing: ease || 'ease-out', fill: 'forwards' }); return; }
    el.style.transition = 'transform ' + dur + 'ms ' + (ease || 'ease-out') + ' ' + (delay || 0) + 'ms, opacity ' + dur + 'ms ease ' + (delay || 0) + 'ms';
    var last = frames[frames.length - 1];
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.style.transform = last.transform; el.style.opacity = last.opacity; }); });
  }
  function fly(fromEl) {
    var b = fromEl.getBoundingClientRect(), t = $('[data-hw-cart-target]'), tr = t ? t.getBoundingClientRect() : { left: window.innerWidth - 60, top: 60, width: 40, height: 20 };
    var x0 = b.left + b.width / 2, y0 = b.top + b.height / 2, dx = tr.left + tr.width / 2 - x0, dy = tr.top + tr.height / 2 - y0;
    var layer = document.createElement('div'); layer.className = 'hw-fly'; document.body.appendChild(layer);
    for (var i = 0; i < 6; i++) {
      var bat = document.createElement('div');
      bat.style.cssText = 'left:' + (x0 - 13) + 'px;top:' + (y0 - 6.5) + 'px;opacity:0;transform:scale(.3)';
      bat.innerHTML = batSVG(26); layer.appendChild(bat);
      var ang = -Math.PI * (0.1 + 0.8 * i / 5), dist = 90 + (i % 2) * 40, cx = Math.cos(ang), sy = Math.sin(ang);
      tween(bat, [
        { transform: 'translate3d(0px,0px,0) scale(.3)', opacity: 0 },
        { transform: 'translate3d(' + (cx * dist * .5).toFixed(1) + 'px,' + (sy * dist * .5).toFixed(1) + 'px,0) scale(1)', opacity: .9, offset: .35 },
        { transform: 'translate3d(' + (cx * dist).toFixed(1) + 'px,' + (sy * dist - 30).toFixed(1) + 'px,0) scale(.8)', opacity: 0 }
      ], 850, i * 30);
    }
    var pk = document.createElement('div');
    pk.style.cssText = 'left:' + (x0 - 20) + 'px;top:' + (y0 - 20) + 'px;opacity:0;-webkit-filter:drop-shadow(0 6px 10px rgba(232,115,28,.45));filter:drop-shadow(0 6px 10px rgba(232,115,28,.45))';
    pk.innerHTML = pumpkinHTML(40); layer.appendChild(pk);
    tween(pk, [
      { transform: 'translate3d(0px,0px,0) scale(.6) rotate(0deg)', opacity: 0 },
      { transform: 'translate3d(' + (dx * .35).toFixed(1) + 'px,' + (dy * .2 - 140).toFixed(1) + 'px,0) scale(1.5) rotate(-25deg)', opacity: 1, offset: .4 },
      { transform: 'translate3d(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px,0) scale(.35) rotate(20deg)', opacity: .9 }
    ], 950, 0, 'cubic-bezier(.45,.05,.4,1)');
    setTimeout(function () { if (layer.parentNode) layer.parentNode.removeChild(layer); }, 1150);
  }

  function initPDP() {
    var root = $('[data-hw-pdp]'); if (!root) return;
    var data = JSON.parse($('#hw-pdp-json').textContent), product = data.product;
    var current = product.variants.filter(function (v) { return v.id === data.selected; })[0] || product.variants[0];
    var qty = 1, mainImg = $('#hw-main-img');
    $$('[data-hw-thumb]', root).forEach(function (t) { t.addEventListener('click', function () { mainImg.src = t.getAttribute('data-hw-thumb'); $$('[data-hw-thumb]', root).forEach(function (x) { x.classList.toggle('on', x === t); }); }); });
    function sync() {
      var opts = current.options;
      $$('[data-opt-index]', root).forEach(function (b) { b.classList.toggle('on', opts[+b.getAttribute('data-opt-index')] === b.getAttribute('data-val')); });
      $$('[data-opt-label]', root).forEach(function (l) { l.textContent = opts[+l.getAttribute('data-opt-label')]; });
      $('#hw-price').textContent = money(current.price);
      var cmp = $('#hw-compare'); if (cmp) { cmp.textContent = current.compare_at_price > current.price ? money(current.compare_at_price) : ''; }
      var atc = $('#hw-atc'); atc.disabled = !current.available; atc.querySelector('span').textContent = current.available ? data.atcLabel : 'Sold out';
      if (current.featured_image && current.featured_image.src) mainImg.src = current.featured_image.src;
      try { if (history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', current.id); history.replaceState({}, '', u.toString()); } } catch (err) {}
    }
    $$('[data-opt-index]', root).forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = +b.getAttribute('data-opt-index'), val = b.getAttribute('data-val'), want = current.options.slice(); want[idx] = val;
        var v = product.variants.filter(function (x) { return x.options.every(function (o, i) { return o === want[i]; }); })[0] || product.variants.filter(function (x) { return x.options[idx] === val; })[0];
        if (v) { current = v; sync(); }
      });
    });
    $$('[data-hw-q]', root).forEach(function (b) { b.addEventListener('click', function () { qty = Math.max(1, qty + (+b.getAttribute('data-hw-q'))); $('#hw-qty').textContent = qty; }); });
    var busy = false;
    $('#hw-atc').addEventListener('click', function (e) {
      e.preventDefault(); if (busy || !current.available) return; busy = true;
      var btn = this, label = btn.querySelector('span'); label.textContent = 'Adding to cart\u2026'; fly(btn);
      var req = Cart.add(current.id, qty);
      setTimeout(function () {
        req.then(function () { Cart.pulse(); return Cart.refresh(); }).then(function () { setTimeout(function () { openOv('hw-cart-ov'); }, 450); })
          .catch(function (err) { alert(err.message); })
          .then(function () { label.textContent = data.atcLabel; busy = false; });
      }, 950);
    });
    var buy = $('#hw-buy'); if (buy) buy.addEventListener('click', function (e) { e.preventDefault(); Cart.add(current.id, qty).then(function () { location.href = '/checkout'; }).catch(function (err) { alert(err.message); }); });
    sync();
  }

  function initReco() {
    $$('[data-hw-reco-url]').forEach(function (el) {
      fetch(el.getAttribute('data-hw-reco-url')).then(function (r) { return r.text(); }).then(function (html) {
        var d = document.createElement('div'); d.innerHTML = html; var inner = d.querySelector('[data-hw-reco-url]');
        if (inner && inner.innerHTML.trim()) { el.innerHTML = inner.innerHTML; initDeco(el); } else { var s = el.closest('.shopify-section'); if (s) s.style.display = 'none'; }
      });
    });
  }

  function initSort() {
    var s = $('#hw-sort'); if (!s) return;
    s.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); location.href = u.toString(); });
  }

  function init() {
    if ($('[data-hw-cream]')) document.body.classList.add('hw-cream');
    initDeco(document); initFX(); initAnn(); initCountdowns(); initPDP(); initReco(); initSort();
    if ($('.hw-cart-count')) Cart.get().then(function (c) { $$('.hw-cart-count').forEach(function (el) { el.textContent = c.item_count; }); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('pageshow', function (e) { if (e.persisted) initFX(); });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) initFX(); });
  document.addEventListener('shopify:section:load', function (e) { initDeco(e.target); });
})();
